import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';

// SVG Icons
import IconPortfolio from './icons/iconPortfolio';
import IconTeam from './icons/iconTeam';
import IconFinder from './icons/iconFinder';

class ThreeKeys extends Component {
  render() {
    return (
      <div className="three-keys">

        <div className="wrap">

          <Fade bottom>
          <div className="icon-container">
            <IconPortfolio />
            <h3>Portfolio for life</h3>
          </div>
          </Fade>

          <Fade bottom>
          <div className="icon-container">
            <IconTeam />
            <h3>Build teams</h3>
          </div>
          </Fade>

          <Fade bottom>
          <div className="icon-container">
            <IconFinder />
            <h3>Fill positions fast</h3>
          </div>
          </Fade>

        </div>

      </div>
    );
  }
}

export default ThreeKeys;



// WEBPACK FOOTER //
// ./src/assets/components/threeKeys.js